import { render, staticRenderFns } from "./found_new.vue?vue&type=template&id=e76342c4&"
import script from "./found_new.vue?vue&type=script&lang=js&"
export * from "./found_new.vue?vue&type=script&lang=js&"
import style0 from "./found_new.vue?vue&type=style&index=0&id=e76342c4&prod&lang=less&less=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports